<ngx-ui-loader></ngx-ui-loader>
<div class="penalty-container">
  <mat-toolbar color="primary" class="header-toolbar">
    <span class="title">⚡ Transformer Penalty Report</span>
    <span class="spacer"></span>
  </mat-toolbar>

  <mat-card class="filter-card">
    <mat-card-content>
      <div class="filter-section">
        <mat-form-field appearance="outline" class="dropdown-field">
          <mat-label>Select Transformer</mat-label>
          <mat-select [(value)]="idFilter" (selectionChange)="filters('transformerId', $event.value)">
            <mat-option *ngFor="let transformer of transformerId" [value]="transformer.serialnumber">
              {{ transformer.serialnumber }} [{{ transformer.sitename }}]
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="unit-cost-field">
          <mat-label>Unit Cost</mat-label>
          <input matInput type="number" [(ngModel)]="unitCost" placeholder="0.0" />
          <span matSuffix>₹</span>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Duration</mat-label>
          <mat-select [(ngModel)]="timeFilter" (selectionChange)="filters('date', $event.value)">
            <mat-option *ngFor="let time of timeOptions" [value]="time">
              {{ time }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="accent" class="calculate-btn-neumorphic" (click)="generateReport()">
          <mat-icon>bolt</mat-icon>
          Calculate
        </button>
      </div>
    </mat-card-content>

    <mat-divider></mat-divider>
    <div class="filter-actions" style="padding: 10px;">
      <span><b>Download:</b></span>
      <button mat-icon-button (click)="exportToExcel()" matTooltip="Export to Excel">
        <img src="../../assets/images/icons8-microsoft-excel-30.png">
      </button>
      <div class="neumorphic-counter">
        <span>Approx Penalty</span>
        <span class="total-penalty-amount">₹{{ totalPenalty.toFixed(2) }}</span>
      </div>
    </div>

  </mat-card>
  <app-alert-dialog *ngIf="showAlert" [message]="alertMessage" (close)="closeAlert()"></app-alert-dialog>



  <mat-card class="table-card">
    <mat-card-content>
      <div class="table-wrapper">
        <table mat-table [dataSource]="dataSource" matSort class="full-table">

          <ng-container *ngFor="let col of reportColumns" [matColumnDef]="col">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              {{ getHeaderName(col) }}
            </th>
            <td mat-cell *matCellDef="let element">
              <span [ngClass]="{
                'penalty-chip': col === 'penalty' && element[col] > 0,
                'threshold-chip': col === 'threshold_pf',
                'actual-chip': col === 'actual_pf' && element[col] < 0.9
              }">
                {{ element[col] }}
              </span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="reportColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: reportColumns;"></tr>
        </table>
      </div>
      <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>

  <!-- Chart -->
  <!-- <mat-card>
    <mat-card-title>Penalty Trend</mat-card-title>
    <mat-card-content>
      <div id="penaltyChart" style="height: 300px;"></div>
    </mat-card-content>
  </mat-card> -->

</div>